import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ModuleGuard } from 'src/app/shared/guards/module.guard';
import { CourseListComponent } from './course/course-list/course-list.component';
import { QuestionCategoryListComponent } from './question-category/question-category-list/question-category-list.component';
import { CourseQuestionListComponent } from './course-question/course-question-list/course-question-list.component';
import { CourseTestListComponent } from './course-test/course-test-list/course-test-list.component';
import { EmpCourseTestListComponent } from './emp-course-test/emp-course-test-list/emp-course-test-list.component';
import { ActiveCourseTestListComponent } from './emp-course-test/active-course-test-list/active-course-test-list.component';
import { EmployeeReportComponent } from './emp-course-test/employee-report/employee-report.component';
import { CourseReportComponent } from './report/course-report/course-report.component';
import { EmployeeCourseAllocationComponent } from './emp-course-test/employee-course-allocation/employee-course-allocation/employee-course-allocation.component';
import { EmployeeResolver } from 'src/app/shared/resolvers/employee.resolver';

const routes: Routes = [
   {
      path: 'trainings',
      component: CourseListComponent,
      canActivate:[ModuleGuard],
      data: {
        title: 'trainings',
        modules:['TRAINING']
      },
    },
    {
      path: 'question-categories',
      component: QuestionCategoryListComponent,
      canActivate:[ModuleGuard],
      data: {
        title: 'question-categories',
        modules:['QUESTION CATEGORY']
      },
    },
    {
      path: 'questions',
      component: CourseQuestionListComponent,
      canActivate:[ModuleGuard],
      data: {
        title: 'questions',
        modules:['COURSE QUESTION']
      },
    },
    {
      path: 'tests',
      component: CourseTestListComponent,
      canActivate:[ModuleGuard],
      data: {
        title: 'tests',
        modules:['COURSE TEST']
      },
    },
    {
      path: 'emp-tests',
      component: EmpCourseTestListComponent,
      canActivate:[ModuleGuard],
      resolve: { employeeId: EmployeeResolver},
      data: {
        title: 'emp-tests',
        modules:['EMPLOYEE TEST']
      },
    },
    {
      path: 'emp-test-report',
      component: EmployeeReportComponent,
      resolve: { employeeId: EmployeeResolver},
      canActivate:[ModuleGuard],
      data: {
        title: 'emp-test-report',
        modules:['TEST REPORT']
      },
    },
    {
      path: 'course-test-report',
      component: CourseReportComponent,
      // canActivate:[ModuleGuard],
      // data: {
      //   title: 'course-test-report',
      //   modules:['COURSE TEST REPORT']
      // },
    },
    {
      path: 'course-tests',
      component: ActiveCourseTestListComponent,
    },
    {
      path: 'employee-course-allocation',
      component: EmployeeCourseAllocationComponent,
      canActivate:[ModuleGuard],
      resolve: { employeeId: EmployeeResolver},
      data: {
        title: 'employee-course-allocation',
        modules:['EMPLOYEE COURSE ALLOCATION']
      },
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CourseRoutingModule { }
